<template>
	<div class="wrap">
		<common-header />
		<div class="layout-contents">
			<router-view />
		</div> 
		<common-footer />
	</div>
</template>


<script>
import Vue          		from 'vue'
import VueRouter    		from 'vue-router'
import axios        		from 'axios'
import { EventBus }     	from './event-bus.js'
import * as VueGoogleMaps 	from 'vue2-google-maps'


Vue.prototype.$axios 		= axios
Vue.prototype.$eventBus 	= new Vue()
Vue.config.devtools 		= false
Vue.config.productionTip 	= false
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBZWoAhbZo4nDxT17clFz56CUAgWtNag-E',
		libraries: 'places',
	},
	installComponents: true
})




/* Router */
import App       			from './pages/common/contants'
import CommonHeader			from './pages/common/header'
import CommonFooter			from './pages/common/footer'

import NotFound				from './pages/common/404Error'


/* Pages */
import Main         		from './pages/main'
import WhatWeDo				from './pages/whatwedo'
import Detail				from './pages/detail'
import Contact				from './pages/contact'
//test db connection
import AddForm				from './pages/AddForm'
import Worklist				from './pages/worklist'
import DetailForm			from './pages/DetailForm'
import ViewDetails			from './pages/ViewDetails'


const router = new VueRouter({
	mode: 		'history',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{ 
			path:'/', 
			component: App,
			beforeEnter: (to, from, next) => {
				next()
			},
			children: [
				{ path:'/',							component:Main,				name:'main',			},
				{ path:'/who-we-are',				component:Main,				name:'who-we-are',		},
				{ path:'/what-we-do',				component:WhatWeDo,			name:'whatwedo',		},
				{ path:'/client/:name',				component:Detail,			name:'detail',			},
				{ path:'/contact',					component:Main,				name:'main-contact',	},
				{ path:'/worklist',					component:Worklist,			name:'worklist',		},
				{ path: '*',						component:NotFound,			name:'404',				},
			]
		},
	],
	methods: {
		
	},
})



export default {
	name: 'app',
	data() {
        return {
			menu_idx : 1
        }
    },
	router,
    components: {
		'common-header':	CommonHeader,
		'common-footer':	CommonFooter,
	},
	mounted() {
		if(this.$route.name == 'main') EventBus.$emit('theme', 'white')
	},
	methods: {

	},
	watch: {
		$route (to, from){
			// console.log(to.name)
			if(to.name != 'main') EventBus.$emit('theme', 'black')
		}
	},

}
</script>


<style lang="scss">
	@import './assets/scss/theme.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue